import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=0b541645&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=ts&"
export * from "./NavBar.vue?vue&type=script&lang=ts&"
import style0 from "./NavBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NavBar.vue?vue&type=style&index=1&id=0b541645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b541645",
  null
  
)

export default component.exports